// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2L13W","icon":"style_icon__2JDND"};